import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Logo } from "../components/Logo";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative overflow-hidden">
        <img
          src="https://customer-assets.emergentagent.com/job_hours-tracker-app-1/artifacts/6rlxr12z_Samanvay_8.jpg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/35" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="ess-section-label mb-3" style={{ color: "#FFFFFF", opacity: 0.9 }}>ESSTEAM DESIGN SERVICES LLP</div>
          <div className="text-3xl font-light leading-tight max-w-md">
            Track every hour with the same precision you bring to architecture.
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <Logo size={36} className="mb-12" />
          <h1 className="text-3xl font-semibold tracking-tight mb-8 text-[var(--ess-ink)]">Sign in</h1>

          <label className="ess-section-label block mb-2">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name.essteam / name.amalgus@gmail.com"
            className="w-full border border-gray-200 px-4 py-3 mb-5 outline-none focus:border-[var(--ess-ink)]"
            data-testid="login-email"
          />

          <label className="ess-section-label block mb-2">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-gray-200 px-4 py-3 mb-6 outline-none focus:border-[var(--ess-ink)]"
            data-testid="login-password"
          />

          {err && <div className="mb-4 text-sm text-red-600" data-testid="login-error">{err}</div>}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[var(--ess-ink)] text-white py-3 text-sm font-medium tracking-wider uppercase hover:bg-[var(--ess-ink-soft)] disabled:opacity-60"
            data-testid="login-submit"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>

          <div className="mt-6 text-sm text-gray-500">
            New here?{" "}
            <Link to="/register" className="text-[var(--ess-ink)] underline" data-testid="link-register">
              Create account
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
